import api from './axiosInstance';

export const inventoryApi = {
  materialUnits: {
    list: () => api.get('/inventory/material-units'),
    create: (data) => api.post('/inventory/material-units', data),
    update: (id, data) => api.put(`/inventory/material-units/${id}`, data),
    remove: (id) => api.delete(`/inventory/material-units/${id}`),
  },
  materialTypes: {
    list: () => api.get('/inventory/material-types'),
    create: (data) => api.post('/inventory/material-types', data),
    update: (id, data) => api.put(`/inventory/material-types/${id}`, data),
    remove: (id) => api.delete(`/inventory/material-types/${id}`),
  },
  readymadeTypes: {
    list: () => api.get('/inventory/readymade-types'),
    create: (data) => api.post('/inventory/readymade-types', data),
    update: (id, data) => api.put(`/inventory/readymade-types/${id}`, data),
    remove: (id) => api.delete(`/inventory/readymade-types/${id}`),
  },
  readymadeSizes: {
    list: () => api.get('/inventory/readymade-sizes'),
    create: (data) => api.post('/inventory/readymade-sizes', data),
    update: (id, data) => api.put(`/inventory/readymade-sizes/${id}`, data),
    remove: (id) => api.delete(`/inventory/readymade-sizes/${id}`),
  },
  materials: {
    list: (search, orgUnitId) => api.get('/inventory/materials', {params: {search, orgUnitId}}),
    get: (id) => api.get(`/inventory/materials/${id}`),
    create: (data) => api.post('/inventory/materials', data),
    update: (id, data) => api.put(`/inventory/materials/${id}`, data),
    remove: (id) => api.delete(`/inventory/materials/${id}`),
    uploadImages: (id, formData) => api.post(`/inventory/materials/${id}/images`, formData, {headers: {'Content-Type': 'multipart/form-data'}}),
  },
  readymades: {
    list: (search, orgUnitId) => api.get('/inventory/readymades', {params: {search, orgUnitId}}),
    get: (id) => api.get(`/inventory/readymades/${id}`),
    create: (data) => api.post('/inventory/readymades', data),
    update: (id, data) => api.put(`/inventory/readymades/${id}`, data),
    remove: (id) => api.delete(`/inventory/readymades/${id}`),
    uploadImages: (id, formData) => api.post(`/inventory/readymades/${id}/images`, formData, {headers: {'Content-Type': 'multipart/form-data'}}),
  },
  purchaseOrders: {
    list: (from, to, catalogItemType, orgUnitId) =>
      api.get('/purchase-orders', {params: {from, to, catalogItemType, orgUnitId}}),
    get: (id) => api.get(`/purchase-orders/${id}`),
    create: (data) => api.post('/purchase-orders', data),
    update: (id, data) => api.put(`/purchase-orders/${id}`, data),
    updateStatus: (id, status) => api.put(`/purchase-orders/${id}/status`, {status}),
    remove: (id) => api.delete(`/purchase-orders/${id}`),
  },
};
